import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal, Button, Icon, Loader, Progress } from 'semantic-ui-react';
import { PROMPT_PAY_TYPE , CARD_TYPE } from "react-lib/apps/MEH/sequence/BillingAndPackage"
import jwt_encode from "jwt-encode";
import { jwtDecode } from 'jwt-decode';


type CardChoosePaidTypePackageModalProps = {
  BillingAndPackageSequence: any;
  runSequence: any;
  setProp: any;
  userProfile: any;
}


const PAYMENT_METHODS = [
  {
    id: CARD_TYPE,
    icon: '💳',
    iconBg: '#ffe5ec',
    title: 'บัตรเครดิต / บัตรเดบิต',
    logos: [
      'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg',
      'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg'
    ]
  },
  {
    id: PROMPT_PAY_TYPE,
    iconUrl: 'static/images/promptpay.png',
    iconBg: '#e3f2fd',
    title: 'คิวอาร์พร้อมเพย์',
    description: 'สแกนคิวอาร์โค้ดเพื่อจ่าย'
  }
];

const CardChoosePaidTypePackageModal = (props: CardChoosePaidTypePackageModalProps) => {
  const [selectedMethodId, setSelectedMethodId] = useState("");
  const [qrCode, setQrCode] = useState("")
  // const [showIframe, setShowIFrame] = useState(false)
  // const [token, setToken] = useState('');

  useEffect(() => {
    props.runSequence({
      sequence: "BillingAndPackage",
      action: "GET_PAID_CHOICE",
    })
    return () => {
      if (props.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
        props.BillingAndPackageSequence?.paymentCheckerPolling?.stop()
      }
    }
    
  }, [])

  const onClose = () => {
    if (!!props.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
      props.BillingAndPackageSequence?.paymentCheckerPolling?.stop()
    }
    props.setProp("BillingAndPackageSequence", {
      ...props.BillingAndPackageSequence,
      openPaidPackageModal: false,
      paymentCheckerPolling : null,
      //TODO: need change to other location
      transactions: {...props.BillingAndPackageSequence?.transactions, prepareInvoice: null}
    })
  }
  const payment_methods = useMemo(() => {

     let paymentMethods: any[] = []
    if (props.BillingAndPackageSequence?.paymentMethods?.items) {
      // TODO: filter payment methods
      let allowIds = props.BillingAndPackageSequence?.paymentMethods?.items?.map((i: any) => i.type)
      paymentMethods = PAYMENT_METHODS?.filter((i: any) => allowIds.includes(i.id))

      // TODO: Debug 
      if (props.userProfile?.id === 6832) {
        return PAYMENT_METHODS
      }
    }

    return paymentMethods

  }, [props.BillingAndPackageSequence?.paymentMethods])

  const iframeRef = useRef<any>(null);

  

  useEffect(() => {
    // มี invoice ปัจจุบัน 
    if (props.BillingAndPackageSequence?.transactions?.prepareInvoice) {
      if (selectedMethodId === PROMPT_PAY_TYPE) {


        // Show QRCode 
        if (!qrCode) {
          let base64 = props.BillingAndPackageSequence?.paymentMethods?.items?.find((i: any) => i.type === selectedMethodId)?.qr_image_base64 || ""
          if (base64) {
            setQrCode(base64)
          }
        }

      } else if (selectedMethodId === CARD_TYPE) {
        // Subscribe on post messages
        // window.addEventListener('message', handlePaymentPostMessages);
        props.runSequence({
          sequence: "BillingAndPackage",
          action: "CARD_SELECTED",
        })
      }

      // set periodic checking 
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "START_PERIODIC_PAYMENT_CHECK",
        invoiceId: props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id
      })
    }

  }, [props.BillingAndPackageSequence?.transactions?.prepareInvoice])



  const PaymentCard = ({ method, selected, onClick }) => (
    <div
      onClick={onClick}
      style={{
        border: selected ? '2px solid #e91e63' : '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '1.5rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: selected ? '#fff5f8' : 'white',
        transition: 'all 0.2s',
        marginBottom: '1rem'
      }}
    >
      <div style={{
        width: '50px',
        height: '50px',
        backgroundColor: method.iconBg || '#f5f5f5',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
        fontSize: '1.5rem'
      }}>
        {method.iconUrl ? <img width="25" height="25" src={`/${method.iconUrl}`} /> : method.icon}
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.3rem' }}>
          {method.title}
        </div>
        {method.description && (
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            {method.description}
          </div>
        )}
        {method.logos && (
          <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {method.logos.map((logo, idx) => (
              <img
                key={idx}
                src={logo}
                alt="payment logo"
                style={{ height: '20px', objectFit: 'contain' }}
              />
            ))}
          </div>
        )}
      </div>

      <Icon name="chevron right" size="large" style={{ color: '#bbb' }} />
    </div>
  );

  const triggerSubmitPayment = (paymentType = 'submit_gcard') => {
    if (iframeRef.current) {
      // Possible types to trigger:
      // submit_gcard     - Global Credit Card
      // submit_lcard     - Local Credit Card
      // submit_dpay      - Digital Payment
      // submit_qr        - QR Payment
      // submit_counter   - Counter Payment
      // submit_ssm       - Self Service Machine
      // submit_webpay    - Web Payment / Direct Debit
      // submit_imbank    - iBanking / mBanking
      // submit_gbnpl     - Global Buy Now Pay Later
      
      console.log('paymentType: ', paymentType);
      iframeRef.current?.contentWindow.postMessage(paymentType, '*');
    }
  };


  return (
    <Modal
      open={props.BillingAndPackageSequence.openPaidPackageModal}
      onClose={onClose}
      size="small"
      closeIcon
      closeOnDimmerClick={false}
    >
      <Modal.Header style={{ fontSize: '1.3rem' }}>
        เลือกช่องทางการชำระเงิน
      </Modal.Header>

      <Modal.Content>
        <div style={{ marginBottom: '1rem', color: '#666', fontSize: '0.95rem' }}>
          ช่องทางแนะนำ
        </div>

        {payment_methods.map((method) => (
          <PaymentCard
            key={method.id}
            method={method}
            selected={selectedMethodId === method.id}
            onClick={() => {
              if (selectedMethodId === method.id) {
                setSelectedMethodId("")
              } else {
                setSelectedMethodId(method.id)
              }
            }
            }
          />
        ))}

        { qrCode ? <div style={{ display: "flex", justifyContent: "center" }}> <br /> <img src={`data:image/png;base64,${qrCode}`} alt="Image" />  </div> : null}

        { qrCode ? <div> DEBUG: invoice Id: {props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id} </div> : null } 
        { qrCode ? <div> DEBUG: total_price_included_vat: {props.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat} </div> : null } 
        
        { props.BillingAndPackageSequence?.paymentCheckerPolling?.stop ? <div> Checking...</div> : null }
       {/* {showIframe && (
        <>
          <iframe
            ref={iframeRef}
            name="output_frame"
            id="output_frame"
            src={paymentUrl}
            width="800"
            height="600"
            style={{ border: '1px solid #ccc', marginTop: '20px' }}
            title="Payment Gateway"
          />
          <br />
          <button
            type="button"
            onClick={() => triggerSubmitPayment('submit_gcard')}
            style={{
              width: '200px',
              height: '80px',
              marginTop: '20px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            PAY NOW
          </button>
        </>
      )} */}
        
      </Modal.Content>
      { !!(props.BillingAndPackageSequence?.paymentCheckerPolling?.stop) ? <Progress style={{borderRadius: 0}} percent={100} attached='bottom'  active />:null}
      <Modal.Actions style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1.5rem'
      }}>
        <Button
          size="large"
          onClick={() => {
            props.runSequence({
              sequence: "BillingAndPackage",
              action: "BACK_TRANSACTION_SUMMARY",
            })
          }}
          style={{
            backgroundColor: '#9e9e9e',
            color: 'white',
            flex: 1,
            marginRight: '1rem'
          }}
        >
          ย้อนกลับ
        </Button>
        <Button
          size="large"
          disabled={(!selectedMethodId) || ((selectedMethodId === PROMPT_PAY_TYPE) && !!qrCode ) || !!props.BillingAndPackageSequence?.paymentCheckerPolling?.stop }
          onClick={async () => {

            // Create Invoice 
            await props.runSequence({ sequence: "BillingAndPackage", action: "CREATE_INVOICE" })

          }}
          style={{
            backgroundColor: selectedMethodId ? '#e91e63' : '#ccc',
            color: 'white',
            flex: 1.5
          }}
        >
          ดำเนินการชำระเงิน
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CardChoosePaidTypePackageModal;